import * as firebase from 'firebase/app'


const blobs = {}


export const saveBlob = (blob) => {
  const url = window.URL.createObjectURL(blob)

  blobs[url] = blob
  return url
}

export const getBlob = url => blobs[url]

export const removeBlob = url => window.URL.revokeObjectURL(url)

export const flushBlobs = () => Object.keys(blobs).forEach(removeBlob)


const storage = {
  put: async (name, file, contentType, customMetadata = {}) => {
    const task = await firebase.storage().ref(name).put(file, {
      contentType,
      customMetadata,
    })

    return task.metadata.ref
  },

  get: async (filename) => {
    const url = await firebase.storage().ref(filename).getDownloadURL()
    const response = await fetch(url)
    const blob = await response.blob()

    return saveBlob(blob)
  },
}


export default storage
